import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { ProcessDto } from './dtos/process.dto'
import { TechniqueNames } from './dtos/technique.dto'

@Injectable()
export class ProcessesService {
  private http = inject(HttpClient)

  private baseUrl = 'rest/processes'

  public getAllProcesses(): Observable<ProcessDto[]> {
    return this.http.get<ProcessDto[]>(this.baseUrl)
  }

  public getProcessByName(processName: string): Observable<ProcessDto> {
    return this.http.get<ProcessDto>(`${this.baseUrl}/${processName}`)
  }

  public getProcessesByTechnique(
    techniqueName: TechniqueNames,
  ): Observable<ProcessDto[]> {
    return this.http.get<ProcessDto[]>(
      `${this.baseUrl}/technique/${techniqueName}`,
    )
  }
}
